var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "middle", staticClass: "main-center" }, [
    _c("img", {
      staticStyle: { width: "100%" },
      attrs: { src: require("@/assets/img/driver1.png"), alt: "" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }